export default class RulesetContext {
    constructor() {
        this.appliedRules = [];
    }

    isRuleApplied(ruleName) {
        return this.appliedRules.some((r) => r === ruleName);
    }
}
